import { WithdrawTagType } from '@golden/gdk-admin'
import TKeyType from '../../i18ns/admin/TKeyType'

const withdrawTagTypeName: { [key in WithdrawTagType]: TKeyType } = {
  [WithdrawTagType.AGENT_WALLET]: 'withdraw.agent_transfer_withdraw',
  [WithdrawTagType.CRYPTO]: 'common.cryptoText',
  [WithdrawTagType.RMB]: 'common.rmbText',
  [WithdrawTagType.WALLET]: 'common.digitalWallet'
}

export default withdrawTagTypeName
